import { HashRouter as Router, Routes as Switch, Route } from 'react-router-dom'

import { GlobalBottomSheet } from '@/components/DynamicComponent/GlobalBottomSheet'

import routes from './routes'

const Routes = () => (
  <Router basename="/">
    <Switch>
      {routes.map((route) => (
        <Route path={route.path} key={route.path} element={<route.component />} />
      ))}
    </Switch>
    <GlobalBottomSheet />
  </Router>
)

export default Routes
